import { useRef } from "react";
import SolicitudesPendientes from "./SolicitudesPendientes";
import UsuariosPendientes from "./UsuariosPendientes";
import PropuestasPendientes from "./PropuestasPendientes";
import PlanificacionesProximas from "./PlanificacionesProximas";
import ActividadesAbiertas from "./ActividadesAbiertas";
import ActividadesEnEnsayo from "./ActividadesEnEnsayo";
import ActividadesSinDecisor from "./ActividadesSinDecisor";
import MisDestacados from "./MisDestacados";
import MisPasos from "./MisPasos";
import { SoloRoles, PERMISO } from "../../roles";
import { ConPermiso } from "../../shared";
import ImportacionesPendientes from "./ImportacionesPendientes";
import useConPenta from "../importaciones/useConPenta";
import CertificadosVencidos from "./CertificadosVencidos";
import ArchivosClientes from "./ArchivosClientes";
import HallazgosPendientes from "./HallazgosPendientes";
import SolicitudesExtension from "./SolicitudesExtension";
import PagosColaboradoresPendientes from "./PagosColaboradoresPendientes";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";

export default function Tablero() {
  const toast = useRef(null);
  const conPenta = useConPenta();

  return (
    <main>
      <Toast ref={toast} position="top-center" />
      {/* Un único ConfirmDialog para toda la portada: el confirmDialog()
          imperativo se renderiza en TODOS los <ConfirmDialog/> montados, así
          que tener uno solo evita popups duplicados. */}
      <ConfirmDialog />
      <MisDestacados toast={toast} />
      <SoloRoles roles={PERMISO.TENER_PASOS_ASIGNADOS}>
        <MisPasos toast={toast} />
      </SoloRoles>
      <SolicitudesPendientes toast={toast} />
      <SolicitudesExtension toast={toast} />
      <UsuariosPendientes toast={toast} />
      {/* De acá para abajo, orden alfabético por el título de cada acordeón. */}
      <ActividadesAbiertas toast={toast} />
      <ActividadesSinDecisor toast={toast} />
      <ActividadesEnEnsayo toast={toast} />
      <ArchivosClientes toast={toast} />
      <HallazgosPendientes toast={toast} />
      {conPenta && <ImportacionesPendientes toast={toast} />}
      {/* Los pagos a colaboradores entran en el permiso de facturación */}
      <ConPermiso clave="admin.facturacion">
        <PagosColaboradoresPendientes toast={toast} />
      </ConPermiso>
      <PlanificacionesProximas toast={toast} />
      {/* Las propuestas comerciales entran en el permiso de facturación */}
      <ConPermiso clave="admin.facturacion">
        <PropuestasPendientes toast={toast} />
      </ConPermiso>
      <CertificadosVencidos toast={toast} />
    </main>
  );
}
